export const ELEMENTS_HAVING_DATA_JSOBJ_EXCLUDING_LATE_INIT = `[data-js]:not([data-js-init]), [data-jsobj]:not([data-js-init])`;
export const ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT = `[data-js], [data-jsobj], [data-jsobjpopin]`;
